export var PATHS;
(function (PATHS) {
    PATHS["HOME"] = "/";
    PATHS["RESULTS"] = "/results/:responseId";
})(PATHS || (PATHS = {}));
